module.exports = __webpack_public_path__ + "img/15.26affdd6.png";